var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ArticleCards.length>0)?_c('div',[_c('Title',{attrs:{"config":_vm.config,"language":_vm.language}}),_c('Layout',{attrs:{"preKey":_vm._category,"columnComponents":_vm.ArticleCards,"language":_vm.language},on:{"readMore":_vm.readMore}})],1):_c('div',[_c('center',[_vm._v(" Check back for new articles, and events ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }